/*
 * All reducers get two parameters passed in, state and action that occurred
 *       > state isn't entire apps state, only the part of state that this reducer is responsible for
 * */

// "state = null" is set so that we don't throw an error when app first boots up

// eslint-disable-next-line

const locaUserLogged = JSON.parse(localStorage.getItem('currentUser')) || {};

export default function (state = locaUserLogged, action) {
    switch (action.type) {
        case 'SET_CURRENT_USER':
            localStorage.setItem('currentUser', JSON.stringify(action.payload));
            return action.payload;

        default:
            return state;
    }

}
